import type { PropsWithChildren, Ref } from 'react';
import ButtonAction from '../../interfaces/buttonAction';
import BreakLine from '../commons/break-line';
import NavigationFooter from '../navigation-footer';
import * as styles from './Layout.module.css';

interface LayoutProps {
  backButton?: ButtonAction;
  nextButton: ButtonAction;
  displayNavigationFooter?: boolean;
  displayBreakLine?: boolean;
  ref?: Ref<HTMLDivElement>;
}

const Layout = ({
  children,
  backButton,
  nextButton,
  displayNavigationFooter = true,
  displayBreakLine = true,
  ref,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <>
      <div ref={ref} className={styles.appContainer} data-testid="app-container">
        {displayBreakLine && <BreakLine />}
        {children}
        {displayNavigationFooter && (
          <NavigationFooter backButton={backButton} nextButton={nextButton} />
        )}
      </div>
    </>
  );
};

export default Layout;
